import { __assign } from "tslib";
import * as React from 'react';
import { default as MuiMenu } from '@material-ui/core/Menu';
export var defaultMenuPlacement = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
    getContentAnchorEl: null,
};
export var Menu = React.forwardRef(function (props, ref) { return (React.createElement(MuiMenu, __assign({}, defaultMenuPlacement, { ref: ref }, props))); });
export default Menu;
//# sourceMappingURL=Menu.js.map